<script>

import { modalStyle, trans } from '@/utils';
import { createEventDispatcher } from 'svelte';
import { fly } from 'svelte/transition';
import Svelecte from 'svelecte';

export let data;

export let disabledOptions = {};

export let clear_toggle = false;

export let closed = true;

const dispatch = createEventDispatcher();


let regions = [];
let sizes = [];
let types = [];
let sectors = [];
let statuses = [];
let stakeholders = [];
let policies = [];
let ai_types = []
let local_govt = [];
let cc4dr = false;
let organizations = [];

const close = () => {
    dispatch('close');
}

const notify = () => {
    const data = { regions, sizes, types, sectors, statuses, cc4dr, stakeholders, policies, ai_types, local_govt, organizations };
    dispatch('change', data);
}

const clear = () => {
  regions = [];
  sizes = [];
  types = [];
  sectors = [];
  statuses = [];
  cc4dr = false;
  stakeholders = [];
  policies = [];
  ai_types = [];
  local_govt = [];
  organizations = [];
}

const reset = () => {
  clear();
  dispatch('reset');
}

$: clear_toggle, clear();

let div; // div

let expanded = null;

$: {
    if (closed) {
        modalStyle('closed');
    } else {
        if (div) info.scrollTop = 0;
        modalStyle('open');
    }
}

const toggle = (section) => {
  if (expanded === section) {
    expanded = null;
  } else {
    expanded = section;
  }
}

</script>


<div class="overlay" class:closed on:click={close}></div>
<div id="filter" bind:this={div} class:closed class="bg-modal p-lg-5 p-4">

    <button type="button" class="btn btn-link text-white p-0 m-3 text-underline-none position-absolute end-0 top-0 fs-5" on:click={close}>
      <i class="fa-regular fa-xmark-large"></i>
    </button>

    <div class="pb-5 fs-2">
      {trans('filter_by')}
    </div>

    <div id="acc-filters">

      <div class="box mb-5">
        <div class="box-title fs-4">{trans('filter_title_city')}</div>
        <div class="box-body">

          <!-- POPULATION -->
          <div class="accordion-item">
            <div class="accordion-header" id="acc-header-pop">
              <button class="accordion-button collapsed m-0 p-0" class:collapsed={expanded!=='sizes'} on:click={() => toggle('sizes')}  type="button" aria-controls="acc-filter-pop">
                {trans('filter_by_population')} {#if sizes.length}({sizes.length}){/if}
              </button>
            </div>
            <div id="acc-filter-pop" class="accordion-collapse" class:closed={expanded!=='sizes'}>
              <div class="accordion-body p-0 small">
                  {#each data.sizes as t (t.id)}
                  {@const disabled = disabledOptions.sizes && disabledOptions.sizes[t.id]}
                  {@const show = expanded ==='sizes' || sizes.includes(t.id)}
                  {#if show}
                  <div class="form-check custom-inputs" in:fly>
                      <input class="form-check-input" type="checkbox" {disabled} bind:group="{sizes}" value="{t.id}" id="pop-{t.id}" on:change={notify}>
                      <label class="form-check-label" for="pop-{t.id}">
                          {t.name}
                      </label>
                  </div>
                  {/if}
                  {/each}
              </div>
            </div>
          </div>

          <!-- CCDR -->
          <div class="accordion-item">
            <div class="accordion-header" id="acc-header-member">
              <button class="accordion-button collapsed m-0 p-0" class:collapsed={expanded!=='cc4dr'} on:click={() => toggle('cc4dr')}  type="button" aria-controls="acc-filter-member">
                {trans('filter_by_ccdr')} {#if cc4dr}(1){/if}
              </button>
            </div>
            <div id="acc-filter-member" class="accordion-collapse" class:closed={expanded!=='cc4dr'}>
              <div class="accordion-body p-0 small">
                  {#if expanded ==='cc4dr' || cc4dr}
                  <div class="form-check custom-inputs" in:fly>
                      <input class="form-check-input" disabled={disabledOptions.cc4dr} type="checkbox" bind:checked={cc4dr} id="member-cc4dr" on:change={notify}>
                      <label class="form-check-label" for="member-cc4dr">
                        {trans('cc4dr_member')}
                      </label>
                  </div>
                  {/if}
              </div>
            </div>
          </div>

        </div>
      </div>


      <div class="box mb-5">
        <div class="box-title fs-4">{trans('filter_title_origin')}</div>
        <div class="box-body">

          <!-- GEOGRAPHIC LOCATION -->
          <div class="accordion-item">
            <div class="accordion-header" id="acc-header-geo">
              <button class="accordion-button m-0 p-0" class:collapsed={expanded!=='regions'} on:click={() => toggle('regions')} type="button" aria-controls="acc-filter-geo">
                {trans('filter_by_location')} {#if regions.length}({regions.length}){/if}
              </button>
            </div>
            <div id="acc-filter-geo" class="accordion-collapse" class:closed={expanded!=='regions'}>
              <div class="accordion-body p-0 small">
                  {#each data.regions as t (t.id)}
                  {@const disabled = disabledOptions.regions && disabledOptions.regions[t.id]}
                  {@const show = expanded==='regions' || regions.includes(t.id)}
                  {#if show}
                  <div class="form-check custom-inputs" in:fly>
                      <input class="form-check-input" type="checkbox" {disabled} bind:group="{regions}" value="{t.id}" id="region-{t.id}" on:change={notify}>
                      <label class="form-check-label" for="region-{t.id}">
                          {t.name}
                      </label>
                  </div>
                  {/if}
                  {/each}
              </div>
            </div>
          </div>

          <!-- LOCAL GOVERNMENT INVOLVED -->
          <!--
          <div class="accordion-item">
            <div class="accordion-header" id="acc-header-gvt">
              <button class="accordion-button m-0 p-0" class:collapsed={expanded!=='local_govt'} on:click={() => toggle('local_govt')} type="button" aria-controls="acc-filter-gvt">
                {trans('filter_by_local_govt')} {#if local_govt.length}({stakeholders.length}){/if}
              </button>
            </div>
            <div id="acc-filter-gvt" class="accordion-collapse" class:closed={expanded!=='local_govt'}>
              <div class="accordion-body p-0 small">
                  {#each data.local_govt as t (t.id)}
                  {@const disabled = disabledOptions.local_govt && disabledOptions.local_govt[t.id]}
                  {@const show = expanded==='local_govt' || local_govt.includes(t.id)}
                  {#if show}
                  <div class="form-check custom-inputs" in:fly>
                      <input class="form-check-input" type="checkbox" {disabled} bind:group="{local_govt}" value="{t.id}" id="gvt-{t.id}" on:change={notify}>
                      <label class="form-check-label" for="gvt-{t.id}">
                          {t.name}
                      </label>
                  </div>
                  {/if}
                  {/each}
              </div>
            </div>
          </div>
          -->

          <!-- STAKEHOLDERS -->
          <!--
          <div class="accordion-item">
            <div class="accordion-header" id="acc-header-stake">
              <button class="accordion-button m-0 p-0" class:collapsed={expanded!=='stakeholders'} on:click={() => toggle('stakeholders')} type="button" aria-controls="acc-filter-stake">
                {trans('filter_by_stakeholders')} {#if stakeholders.length}({stakeholders.length}){/if}
              </button>
            </div>
            <div id="acc-filter-stake" class="accordion-collapse" class:closed={expanded!=='stakeholders'}>
              <div class="accordion-body p-0 small">
                  {#each data.stakeholders as t (t.id)}
                  {@const disabled = disabledOptions.stakeholders && disabledOptions.stakeholders[t.id]}
                  {@const show = expanded==='stakeholders' || stakeholders.includes(t.id)}
                  {#if show}
                  <div class="form-check custom-inputs" in:fly>
                      <input class="form-check-input" type="checkbox" {disabled} bind:group="{stakeholders}" value="{t.id}" id="stake-{t.id}" on:change={notify}>
                      <label class="form-check-label" for="stake-{t.id}">
                          {t.name}
                      </label>
                  </div>
                  {/if}
                  {/each}
              </div>
            </div>
          </div>
          -->

          <!-- ORGANIZATION -->
          <!--
          <div class="accordion-item">
            <div class="accordion-header" id="acc-header-org">
              <button class="accordion-button m-0 p-0" class:collapsed={expanded!=='organizations'} on:click={() => toggle('organizations')} type="button" aria-controls="acc-filter-org">
                {trans('filter_by_organization')} {#if organizations.length}({organizations.length}){/if}
              </button>
            </div>
            <div id="acc-filter-org" class="accordion-collapse" class:closed={expanded!=='organizations'}>
              <div class="accordion-body p-0 small">
                {#if expanded==='organizations'}
                <div class="mt-2">
                <Svelecte inputId="frm-organizations" options={data.organizations} bind:value={organizations} multiple={true}
                  valueField="id" labelField="name" creatable={false} placeholder="Start typing for options"
                  on:change={notify} />
                </div>
                {/if}
              </div>
            </div>
          </div>
          -->

        </div>
      </div>


      <div class="box mb-5">
        <div class="box-title fs-4">{trans('filter_title_type')}</div>
        <div class="box-body">

          <!-- TYPE OF INITIATIVE -->
          <div class="accordion-item">
            <div class="accordion-header" id="acc-header-type">
              <button class="accordion-button collapsed m-0 p-0" class:collapsed={expanded!=='types'} on:click={() => toggle('types')}  type="button" aria-controls="acc-filter-type">
                {trans('filter_by_type')} {#if types.length}({types.length}){/if}
              </button>
            </div>
            <div id="acc-filter-type" class="accordion-collapse" class:closed={expanded!=='types'}>
              <div class="accordion-body p-0 small">
                  {#each data.types as t (t.id)}
                  {@const disabled = disabledOptions.types && disabledOptions.types[t.id]}
                  {@const show = expanded ==='types' || types.includes(t.id)}
                  {#if show}
                  <div class="form-check custom-inputs" in:fly>
                      <input class="form-check-input" type="checkbox" {disabled} bind:group="{types}" value="{t.id}" id="typ-{t.id}" on:change={notify}>
                      <label class="form-check-label" for="typ-{t.id}">
                          {t.name}
                      </label>
                  </div>
                  {/if}
                  {/each}
              </div>
            </div>
          </div>

          <!-- POLICY MECHANISM -->
          <!--
          <div class="accordion-item">
            <div class="accordion-header" id="acc-header-pol">
              <button class="accordion-button collapsed m-0 p-0" class:collapsed={expanded!=='policies'} on:click={() => toggle('policies')}  type="button" aria-controls="acc-filter-pol">
                {trans('filter_by_policy')} {#if policies.length}({policies.length}){/if}
              </button>
            </div>
            <div id="acc-filter-pol" class="accordion-collapse" class:closed={expanded!=='types'}>
              <div class="accordion-body p-0 small">
                  {#each data.policies as t (t.id)}
                  {@const disabled = disabledOptions.policies && disabledOptions.policies[t.id]}
                  {@const show = expanded ==='policies' || policies.includes(t.id)}
                  {#if show}
                  <div class="form-check custom-inputs" in:fly>
                      <input class="form-check-input" type="checkbox" {disabled} bind:group="{policies}" value="{t.id}" id="pol-{t.id}" on:change={notify}>
                      <label class="form-check-label" for="pol-{t.id}">
                          {t.name}
                      </label>
                  </div>
                  {/if}
                  {/each}
              </div>
            </div>
          </div>
          -->

          <!-- LEVEL OF IMPLEMENTATION -->
          <div class="accordion-item">
            <div class="accordion-header" id="acc-header-level">
              <button class="accordion-button collapsed m-0 p-0" class:collapsed={expanded!=='statuses'} on:click={() => toggle('statuses')}  type="button" aria-controls="acc-filter-level">
                {trans('filter_by_status')} {#if statuses.length}({statuses.length}){/if}
              </button>
            </div>
            <div id="acc-filter-level" class="accordion-collapse" class:closed={expanded!=='statuses'}>
              <div class="accordion-body p-0 small">
                  {#each data.statuses as t (t.id)}
                  {@const disabled = disabledOptions.statuses && disabledOptions.statuses[t.id]}
                  {@const show = expanded ==='statuses' || statuses.includes(t.id)}
                  {#if show}
                  <div class="form-check custom-inputs" in:fly>
                      <input class="form-check-input" type="checkbox" {disabled} bind:group="{statuses}" value="{t.id}" id="level-{t.id}" on:change={notify}>
                      <label class="form-check-label" for="level-{t.id}">
                          {t.name}
                      </label>
                  </div>
                  {/if}
                  {/each}
              </div>
            </div>
          </div>

          <!-- GENERAL/SPECIFIC -->
          <!--
          <div class="accordion-item">
            <div class="accordion-header" id="acc-header-ai">
              <button class="accordion-button collapsed m-0 p-0" class:collapsed={expanded!=='ai_types'} on:click={() => toggle('ai_types')}  type="button" aria-controls="acc-filter-ai">
                {trans('filter_by_ai_type')} {#if ai_types.length}({ai_types.length}){/if}
              </button>
            </div>
            <div id="acc-filter-ai" class="accordion-collapse" class:closed={expanded!=='ai_types'}>
              <div class="accordion-body p-0 small">
                  {#each data.ai_types as t (t.id)}
                  {@const disabled = disabledOptions.ai_types && disabledOptions.ai_types[t.id]}
                  {@const show = expanded ==='ai_types' || ai_types.includes(t.id)}
                  {#if show}
                  <div class="form-check custom-inputs" in:fly>
                      <input class="form-check-input" type="checkbox" {disabled} bind:group="{ai_types}" value="{t.id}" id="ai-{t.id}" on:change={notify}>
                      <label class="form-check-label" for="ai-{t.id}">
                          {t.name}
                      </label>
                  </div>
                  {/if}
                  {/each}
              </div>
            </div>
          </div>
          -->

          <!-- SECTOR -->
          <div class="accordion-item">
            <div class="accordion-header" id="acc-header-sector">
              <button class="accordion-button collapsed m-0 p-0" class:collapsed={expanded!=='sectors'} on:click={() => toggle('sectors')}  type="button" aria-controls="acc-filter-sector">
                {trans('filter_by_sector')} {#if sectors.length}({sectors.length}){/if}
              </button>
            </div>
            <div id="acc-filter-sector" class="accordion-collapse" class:closed={expanded!=='sectors'}>
              <div class="accordion-body p-0 small">
                  {#each data.sectors as t (t.id)}
                  {@const disabled = disabledOptions.sectors && disabledOptions.sectors[t.id]}
                  {@const show = expanded ==='sectors' || sectors.includes(t.id)}
                  {#if show}
                  <div class="form-check custom-inputs" in:fly>
                      <input class="form-check-input" type="checkbox" {disabled} bind:group="{sectors}" value="{t.id}" id="sector-{t.id}" on:change={notify}>
                      <label class="form-check-label" for="sector-{t.id}">
                          {t.name}
                      </label>
                  </div>
                  {/if}
                  {/each}
              </div>
            </div>
          </div>

        </div>
      </div>


    </div>


    <div class="mt-5 text-center">
      <button type="button" class="btn btn-sm btn-light border-0 text-decoration-none" on:click={reset}>
        <i class="fa-light fa-arrow-rotate-right me-1"></i> {trans('btn_reset_filters')}
      </button>
    </div>

</div>

<style>

.custom-inputs:first-child {
  padding-top: 0.5rem!important;
}
.custom-inputs:last-child {
  padding-bottom: 0.5rem!important;
}

</style>
